import { createListenerMiddleware } from '@reduxjs/toolkit';
//
import registerAuthListeners from './listeners/auth.listeners';

const chainListenerMiddleware = createListenerMiddleware();

const addListener = chainListenerMiddleware.startListening;

registerAuthListeners(addListener);

export default chainListenerMiddleware.middleware;
